module.exports = __webpack_public_path__ + "static/accelerate-2c3ef3d5459c3b34a1e0bb67fdfe5f1d.svg";